import React from 'react';
import {
  EVBox, EVTypography, EVCircularProgress,
} from '@eagleview/ev-comp-library';
import PropTypes from 'prop-types';
import useStyles from '../Authorize.style';

const AutoProvision = ({ progress }) => {
  const classes = useStyles();
  return (
    <>
      <EVBox className={classes.autoProvisionBox}>
        <EVBox classes={{ root: classes.container }}>
          <EVCircularProgress variant="static" value={progress} size={60} />
          <EVBox classes={{ root: classes.labelContainer }}>
            <EVTypography
              variant="caption"
              component="div"
              color="textSecondary"
            >
              {`${Math.round(progress)}%`}
            </EVTypography>
          </EVBox>
        </EVBox>
        <EVBox className={classes.autoProvisionMsg}>
          <EVTypography className={classes.msgStyle}>
            Welcome to EagleView
          </EVTypography>
          <EVTypography className={classes.msgStyle}>
            We are currently provisioning your account with required access. Thank you for your patience!
          </EVTypography>
          <EVTypography className={classes.msgStyle}>
            For any queries, reach out to our
            <a href="https://www.eagleview.com/support/" style={{ color: '#007CAD', fontWeight: '600', textDecoration: 'none' }}> Support</a>
          </EVTypography>
        </EVBox>
      </EVBox>
    </>
  );
};

AutoProvision.propTypes = {
  /**
     * @property {Number} progress - A method which is triggered for translation.
     */
  progress: PropTypes.number.isRequired,
};

export default AutoProvision;
